import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import Modal from '@material-ui/core/Modal';

import { onCloseModal } from '../../store/actions/modal';

const StyledModal = styled(Modal)`
  display: flex !important;
  align-items: center !important;
  flex-direction: column !important;
  justify-content: center !important;
`;

function Connected({ handleClose, children }) {
  return (
    <StyledModal open onClose={handleClose}>
      {children}
    </StyledModal>
  );
}

Connected.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
  handleClose: PropTypes.func.isRequired,
};

const mapDispatchToProps = d => ({
  handleClose: () => d(onCloseModal()),
});

export default connect(
  null,
  mapDispatchToProps
)(Connected);
